import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Card } from '@betterment/samba-react';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { SearchSheet } from '../../../account-security/components/search/SearchSheet';
import { EnvelopeAccountTransactionOptionsDocument } from '../transfer-deposit-card/graphql/envelopeAccountTransactionOptions.generated';

const Content: React.FC = () => {
  const accountId = useRequiredParam('accountId');

  const { data } = useGraphQLQuery(EnvelopeAccountTransactionOptionsDocument, {
    variables: { id: accountId },
    throwOnError: true,
  });

  if (!data) return <CardLoader />;

  if (data.account.__typename !== 'DirectTradingAccount') return null;

  return (
    <Card>
      <Card.Content css={{ padding: 'space.300' }}>
        <SearchSheet accountId={accountId} />
      </Card.Content>
    </Card>
  );
};

export const SecuritySearchCard: React.FC = () => (
  <ErrorBoundary fallbackType="none">
    <Content />
  </ErrorBoundary>
);
